const FB_MIN_WIDTH = 180;
const FB_MAX_WIDTH = 500;

/**
 * Builds a Facebook Page Plugin embed URL.
 *
 * @param {Object} params
 * @param {string}   params.pageUrl      Public Facebook Page URL.
 * @param {string[]} params.tabs         Tabs to show: 'timeline', 'events', 'messages'.
 * @param {number}   params.width        Container width in px (clamped to 180–500).
 * @param {number}   params.height       Container height in px.
 * @param {boolean}  params.smallHeader  Use the small header variant.
 * @param {boolean}  params.hideCover    Hide the cover photo.
 * @param {boolean}  params.showFacepile Show friend facepile.
 * @returns {string} Full embed URL, or '' if pageUrl is empty.
 */
export function buildEmbedSrc( {
	pageUrl,
	tabs = [ 'timeline' ],
	width = 500,
	height = 500,
	smallHeader = false,
	hideCover = false,
	showFacepile = true,
} ) {
	if ( ! pageUrl ) {
		return '';
	}

	const clampedWidth = Math.max( FB_MIN_WIDTH, Math.min( FB_MAX_WIDTH, Math.round( width ) ) );

	const params = new URLSearchParams( {
		href: pageUrl,
		tabs: Array.isArray( tabs ) ? tabs.join( ',' ) : tabs,
		width: String( clampedWidth ),
		height: String( Math.round( height ) ),
		small_header: smallHeader ? 'true' : 'false',
		hide_cover: hideCover ? 'true' : 'false',
		show_facepile: showFacepile ? 'true' : 'false',
	} );

	return 'https://www.facebook.com/plugins/page.php?' + params.toString();
}
